import colors from '../../constants/Colors';

export const CHART_COLORS = {
  BLUE: '#0666ee',
  RED: '#D33F37',
  ORANGE: '#f6722b',
  GREEN: '#239F4E',
  YELLOW: '#efa831',
  PURPLE: '#805AD5',
};

export const COLOR_PALETTE = Object.values(CHART_COLORS);

export const CHART_STYLES = {
  TEXT_COLOR: colors.REDESIGN_PRIMARY_TEXT,
  LABEL_COLOR: colors.REDESIGN_SECONDARY_TEXT,
  SPLIT_LINE_COLOR: colors.DIVIDER_COLOR,
  BACKGROUND_COLOR: '#fff',
  BORDER_COLOR: '#f0f0f0',
}
